import { DataSet } from 'tw-data-source'
import { dataService, httpService } from 'tw-framework'
import { ref, computed } from 'vue'
import { messageService } from 'tw-ui'

export default class apply_for_trial_controller  {
    constructor(props, context, route) {
        this.props = props
        this.context = context
        this.route = route

        if (!this.dataSet) { this.dataSet = new DataSet() }
        this.apply_for_trial = this.dataSet.createTable('apply_for_trial', {})
        dataService.loadDataDictionary('apply_for_trial', this.apply_for_trial)

        this.visible = ref(false)

        this.resolve = this.props.resolve
        this.reject = this.props.reject
        this.params = computed(() => this.props.params)
    }
    onMounted() {
        if (super.onMounted) { super.onMounted() }
            // 清空数据
            this.apply_for_trial.clear()
            // 新增默认行 
            this.apply_for_trial.datas.push({
                user_name: '',
                phone_no: '',
                enterprise_name: ''
            })
    }
    validate() {
        return this.applyForTrial()
    }
    applyForTrial() {
        return new Promise((resolve, reject) => {
            const data = this.apply_for_trial.datas[0]
        
            httpService.post('apply_for_trial', {}, data).then(() => {
                messageService.success('已申请演示')
                resolve()
            }).catch(err => {
                if (err) {
                    messageService.error(err.message)    
                }
                reject()
            })
        })
    }
    sendCheckCode() {
        return new Promise((resolve, reject) => {
            if (!this.apply_for_trial.datas[0].phone_no) {
                messageService.info('请填写您的手机再获取验证码')
                reject()
                return
            }
        
            const data = {
                phone: this.apply_for_trial.datas[0].phone_no
            }
        
            httpService.post('send_check_code', {}, data).then(() => {
                messageService.success('验证码已发送')
                resolve()
            }).catch(err => {
                if (err) {
                    messageService.error(err.message)    
                }
                reject()
            })
        })
    }
    clickCancel_e8e7e69f_ea5d() {
        this.reject()
    }
    clickConfirm_a81c747c_961c() {
        this.resolve()
    }
    btnClick_86270a70_d4ae() {
        const e = arguments[0]
        switch(e.event_no) {
            case 'send_check_code':
                this.sendCheckCode()
                break;
            default:
                messageService.error(`不可识别的事件：${e.event_no}`)
                break;
        }
    }
}